import React, { Component } from 'react';
import Util from '../../lib/util.js';
import User from 'services/user2';
import { Msg } from 'react-weui';

class DingIot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      queryParams: {},
      errorMsg: null,
    };
    this.dialogMsg = '';
  }

  init() {
    let search = decodeURIComponent(window.location.search);
    let queryParams = Util.getParamObj(search);

    this.setState({ queryParams: queryParams });

    // queryParams = {
    //   appId: '',
    //   corpId: 'dingcbcc00928ab00728bc961a6cb783455b',
    //   corpName: '%E4%B8%89%E6%96%B9%E5%BA%94%E7%94%A8%E9%9B%86%E6%88%90',
    //   devCorpId: 'ding993b063e6eec3a83a1320dcb25e91351',
    //   isAdmin: 'false',
    //   sign: 'F506AFF85A6050C8AA4D82BB0A3E9CD8FCEE34F3',
    //   tenantId: '54A1C0710A424F3A9A8C8EC60A38AEC4',
    //   tenantSubUserId: '5071B822c4cf638d78cad332a690651970f25471',
    //   timestamp: '1596511439806',
    //   unionId: 'iSQatcD0EQmxLNuvvOiPewfAiEiE',
    //   userId: '154235092724247708',
    //   userName: '%E5%BC%A0%E6%99%93%E8%89%AF',
    // };

    // User.dingIotInit(queryParams).then(response => {
    //   if (response.success) {
    //     let userInfo = response.data.sysUser;
    //     let companyList = response.data.companyList;
    //     User.setUserInfo(userInfo);
    //     User.setCompanyList(companyList);
    //     User.initDefaultCompany();
    //     User.getMenuAuth();
    //     this.props.history.push('/mp/index');
    //   } else {
    //     this.setState({ errorMsg: response.errorMsg });
    //   }
    // });

    //alert(search);
    //'https://local.xiekeyun.com/mp/dingIot?corpld=dingcbcc00928ab00728bc961a6cb783455b&devCorpld=ding993b063e6eec3a83a1320dcb25e91351&isAdmin=false&sign=3E3205AF8015810A1DC17397A0FFEB2141872CA6&timestamp=1596189151133&unionld=iSQatcD0EQmxLNuvvOiPewfAiEiE&userld=154235092724247708&userName=%E5%BC%A0%E6%99%93%E8%89%AF'

    //https://local.xiekeyun.com/mp/dingIot
  }

  componentDidMount() {
    this.init();
  }

  render() {
    let errorMsg = this.state.errorMsg;
    if (errorMsg) {
      return <Msg type="warn" title={errorMsg} />;
    }
    return '';
  }
}

export default DingIot;
